import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App.js";
import "./styles.css";

const root = document.querySelector<HTMLElement>("#root");
if (root === null) throw new Error("Missing #root application mount point");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
